import React from "react";
import MediaQuery from "components/MediaQuery";
import { CLASSES_AND_SPECS } from "../../lib/classes-and-specs";
import Icon from "components/Common/Icon";

const ClassSpecHeader = (props) => {
  const { classType, description, displayClassName, displaySpecName, specType, title } = props;
  const classColor = CLASSES_AND_SPECS.filter((data) => data.class === displayClassName)[0]?.color;

  return (
    <div className="class-spec-header-container">
      <div>
        <Icon
          color={classColor}
          staticDataImg={`https://static.bigbrain.gg/wow/specs/${classType}_${specType}.png`}
          classType="spec-img"
        />
        <div className="title-and-description">
          <h1 className="title">
            <span className="class-spec">
              {displaySpecName} {displayClassName}
            </span>
            {title}
          </h1>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
            <div className="description-wrapper">
              <div className="description">{description}</div>
            </div>
          </MediaQuery>
        </div>
      </div>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
        <div className="description-wrapper">
          <div className="description">{description}</div>
        </div>
      </MediaQuery>
    </div>
  );
};

export default ClassSpecHeader;
